// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `svg:not(:root).svg-inline--fa,
svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}
.svg-inline--fa {
  display: inline-block;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
body.aframe-inspector-opened,
.toggle-edit,
.sponsor-btn {
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Helvetica, Arial, sans-serif;
}
.wf-roboto-n4-active body.aframe-inspector-opened,
.wf-roboto-n4-active .toggle-edit,
.wf-roboto-n4-active .sponsor-btn {
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Helvetica, Arial, sans-serif;
}
body.aframe-inspector-opened {
  background: #1d1d1d;
  color: #fff;
  font-size: 12px;
  margin: 0;
  overflow: hidden;
}
#aframeInspector svg:not(:root).svg-inline--fa,
#aframeInspector svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}
#aframeInspector .svg-inline--fa {
  display: inline-block;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
#aframeInspector #toolbar {
  background-color: #242424;
}
#aframeInspector #toolbar .toolbarActions {
  padding: 0 0 5px;
  display: flex;
  align-items: baseline;
}
#aframeInspector #toolbar .toolbarActions a.disabled {
  color: #666;
  cursor: default;
}
#aframeInspector #toolbar .toolbarActions .helpButtonContainer {
  flex-grow: 1;
  padding-right: 10px;
  text-align: right;
}
#aframeInspector #scenegraph {
  background: #242424;
  border-top: 1px solid #111;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding-top: 32px;
  width: 230px;
}
#aframeInspector #scenegraph .entity {
  background: #242424;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 3px;
  width: 100%;
  white-space: nowrap;
}
#aframeInspector #scenegraph .entity:hover {
  background: #1d2f39;
}
#aframeInspector #scenegraph .entity.active {
  background-color: #155373;
  color: #fff;
}
#aframeInspector #scenegraph .entity.active .component:hover {
  color: #1888c1;
}
#aframeInspector #scenegraph .entity.active .entityActions {
  display: inline;
}
#aframeInspector #scenegraph .entity.novisible.active span,
#aframeInspector #scenegraph .entity.novisible.active svg,
#aframeInspector #scenegraph .entity.novisible.active .collapsespace,
#aframeInspector #scenegraph .entity.novisible.active .id {
  color: #999;
}
#aframeInspector #scenegraph .entity.novisible:not(.active) span,
#aframeInspector #scenegraph .entity.novisible:not(.active) svg,
#aframeInspector #scenegraph .entity.novisible:not(.active) .collapsespace,
#aframeInspector #scenegraph .entity.novisible:not(.active) .id {
  color: #626262;
}
#aframeInspector #scenegraph .component:hover {
  color: #1faaf2;
}
#aframeInspector #scenegraph .entityIcons {
  margin-left: 2px;
}
#aframeInspector #scenegraph .entityActions {
  display: none;
  margin: 0 14px;
}
#aframeInspector #scenegraph .entityActions .button {
  color: #fff;
  font-size: 12px;
  margin-left: 6px;
}
#aframeInspector #scenegraph svg {
  color: #ccc;
}
#aframeInspector #scenegraph .toolbarActions svg:hover,
#aframeInspector #scenegraph .entityActions svg:hover {
  color: #1faaf2;
}
#aframeInspector #scenegraph .active svg {
  color: #fafafa;
}
#aframeInspector #scenegraph .id {
  color: #ccc;
}
#aframeInspector #scenegraph .option.active .id {
  color: #fff;
}
#aframeInspector #scenegraph .collapsespace {
  color: #eee;
  display: inline-block;
  text-align: center;
  width: 14px;
}
#aframeInspector #scenegraph .fa-eye {
  color: #bbb;
}
#aframeInspector #scenegraph .icons a.button {
  color: #fff;
}
#aframeInspector #scenegraph .search {
  padding: 5px;
  font-size: 16px;
  position: relative;
}
#aframeInspector #scenegraph .search input {
  color: #c3c3c3;
  background: #1d1d1d;
  border-radius: 5px;
  height: 22px;
  text-indent: 10px;
  width: 216px;
}
#aframeInspector #scenegraph .search >svg,
#aframeInspector #scenegraph .search a.button {
  position: absolute;
  right: 14px;
  top: 10px;
}
#aframeInspector #scenegraph .outliner {
  background: #242424;
  color: #c3c3c3;
  cursor: default;
  flex: 1 1 auto;
  font-size: 13px;
  height: calc(100% - 98px);
  line-height: normal;
  outline: none;
  overflow-y: auto;
  padding: 0;
  width: 230px;
}
#aframeInspector .scenegraph-bottom {
  background-color: #323232;
  border-top: 1px solid #111;
  bottom: 10;
  height: 40px;
  left: 0;
  z-index: 100;
}
#aframeInspector .scenegraph-bottom a {
  float: right;
  margin: 10px;
}
#aframeInspector svg:not(:root).svg-inline--fa,
#aframeInspector svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}
#aframeInspector .svg-inline--fa {
  display: inline-block;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
#aframeInspector .components {
  background-color: #242424;
  color: #c3c3c3;
  height: 100%;
  overflow: auto;
  position: fixed;
  width: 331px;
}
#aframeInspector div.vec2,
#aframeInspector div.vec3,
#aframeInspector div.vec4 {
  display: inline;
}
#aframeInspector .vec2 input.number,
#aframeInspector .vec3 input.number {
  width: 40px;
}
#aframeInspector .vec4 input.number {
  width: 34px;
}
#aframeInspector .collapsible-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
#aframeInspector .collapsible-header .entityPrint {
  color: #fff;
}
#aframeInspector .collapsible-content {
  padding: 5px 0;
}
#aframeInspector .componentTitle span {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
  color: #fff;
  font-weight: 600;
  vertical-align: bottom !important;
}
#aframeInspector .collapsible .static {
  background: #333;
  border-bottom: 2px solid #242424;
  box-sizing: content-box;
  cursor: pointer;
  height: 16px;
  padding: 8px 10px 12px 10px;
  vertical-align: bottom;
  font-size: 13px;
}
#aframeInspector .collapsible .static:hover {
  background: #393939;
}
#aframeInspector .collapsible .menu {
  text-align: right;
}
#aframeInspector .collapsible .menuafter {
  color: #bbb;
  content: '\\2807';
  font-size: 12px;
  padding: 5px;
  text-align: right;
}
#aframeInspector .collapsible .static {
  margin: 0;
}
#aframeInspector .collapsible .static .collapse-button {
  border: 6px solid transparent;
  float: left;
  height: 0;
  margin-right: 10px;
  margin-left: 2px;
  width: 0;
}
#aframeInspector .collapsible.collapsed .static .collapse-button {
  border-left-color: #c3c3c3;
  margin-top: 4px;
}
#aframeInspector .collapsible:not(.collapsed) .static .collapse-button {
  border-top-color: #c3c3c3;
  margin-top: 7px;
}
#aframeInspector .propertyRow {
  align-items: center;
  display: flex;
  font-size: 13px;
  min-height: 30px;
  padding: 2px 15px;
}
#aframeInspector .propertyRow .text {
  cursor: default;
  display: inline-block;
  overflow: hidden;
  padding-right: 10px;
  text-overflow: ellipsis;
  vertical-align: middle;
  width: 118px;
}
#aframeInspector .propertyRow .map_value {
  margin: 0 0 0 5px;
  width: 68px;
}
#aframeInspector .propertyRow .Select-control {
  font-size: 11px;
  height: 24px;
}
#aframeInspector .propertyRow .Select-placeholder,
#aframeInspector .propertyRow .Select--single > .Select-control .Select-value {
  line-height: 19px;
}
#aframeInspector .propertyRow .Select-input {
  height: 22px;
}
#aframeInspector .propertyRow input[type=text],
#aframeInspector .propertyRow input[type=number],
#aframeInspector .propertyRow input.string,
#aframeInspector .propertyRow input.number {
  background: #1d1d1d;
  color: #1faaf2;
  min-height: 26px;
  padding-bottom: 1px;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 1px;
}
#aframeInspector .propertyRow input[type=text]:last-child,
#aframeInspector .propertyRow input[type=number]:last-child,
#aframeInspector .propertyRow input.string:last-child,
#aframeInspector .propertyRow input.number:last-child {
  padding-right: 0;
}
#aframeInspector .propertyRow input.string {
  padding-left: 8px;
  box-sizing: border-box;
  width: 165px;
}
#aframeInspector .propertyRow input[type=text]:focus,
#aframeInspector .propertyRow input.string:focus {
  box-shadow: none;
}
#aframeInspector .propertyRow .color_value {
  margin: 0 0 0 5px;
  width: 68px;
  letter-spacing: 1px;
}
#aframeInspector .propertyRowDefined .text {
  color: #fafafa;
  font-weight: 500;
}
#aframeInspector .components * {
  vertical-align: middle;
}
#aframeInspector span.subcomponent {
  color: #999;
  float: none !important;
  margin-left: 10px;
  vertical-align: top !important;
}
#aframeInspector #addComponentContainer {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 10px;
  background: #1d1d1d;
}
#aframeInspector #addComponentContainer #addComponent {
  text-align: left;
  width: 200px;
}
#aframeInspector #addComponentContainer #addComponent .select__control {
  background: #161616;
  height: 35px;
  color: #1faaf2;
}
#aframeInspector #addComponentContainer #addComponentHeader {
  font-size: 15px;
  margin: 5px 0 10px 0;
}
#aframeInspector #addComponentContainer input[type=text]:focus {
  box-shadow: none;
}
#aframeInspector .Select-menu-outer .is-focused span {
  color: #fff;
}
#aframeInspector .component-title {
  align-items: center;
  display: flex;
}
#aframeInspector #componentEntityHeader .collapsible-header {
  bottom: 4px;
  position: relative;
}
#aframeInspector #componentEntityHeader .collapse-button {
  display: none;
}
#aframeInspector #componentEntityHeader .static {
  height: 13px;
}
#aframeInspector #componentEntityHeader .entityPrint {
  font-size: 15px;
  padding-left: 5px;
}
#aframeInspector #componentEntityHeader .entityName {
  max-width: 160px;
  top: 0;
}
#aframeInspector #componentEntityHeader .entityIcons {
  color: #fafafa;
}
#aframeInspector #mixinSelect {
  width: 160px;
}
#aframeInspector .propertyRow .texture {
  display: flex;
}
#aframeInspector .propertyRow .texture input {
  margin-left: 0;
  width: 120px;
}
#aframeInspector #componentEntityHeader .gltfIcon img {
  top: 0;
}
#aframeInspector svg:not(:root).svg-inline--fa,
#aframeInspector svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}
#aframeInspector .svg-inline--fa {
  display: inline-block;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
#aframeInspector .entityPrint {
  font-family: system-ui, BlinkMacSystemFont, -apple-system, "Segoe UI", Helvetica, Arial, sans-serif;
  line-height: 1.15em;
}
#aframeInspector .entityName {
  display: inline-block;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  top: 3px;
  white-space: nowrap;
}
#aframeInspector [data-entity-name-type="id"] {
  color: #92374d;
}
#aframeInspector [data-entity-name-type="class"] {
  color: #514b23;
}
#aframeInspector [data-entity-name-type="mixin"] {
  color: #d66853;
}
#aframeInspector .help-lists {
  display: flex;
  justify-content: space-around;
}
#aframeInspector .help-list {
  list-style: none;
  margin: 0;
  padding: 0 0 10px;
  width: 350px;
}
#aframeInspector .help-list li {
  margin-right: 40px;
}
#aframeInspector .help-key-unit {
  line-height: 1.8;
  margin-right: 2em;
  padding: 5px 0;
}
#aframeInspector .help-key {
  bottom: 2px;
  margin-right: 4px;
  min-width: 60px;
  position: relative;
}
#aframeInspector .help-key span {
  background-color: #2e2e2e;
  background-repeat: repeat-x;
  border: 1px solid #666;
  border-radius: 3px;
  box-shadow: 0 0 5px #000;
  color: #999;
  display: inline-block;
  font-size: 12px;
  padding: 0 8px;
  text-align: center;
}
#aframeInspector .help-key-def {
  color: #bbb;
  display: inline-block;
  margin-left: 1em;
}
#aframeInspector svg:not(:root).svg-inline--fa,
#aframeInspector svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}
#aframeInspector .svg-inline--fa {
  display: inline-block;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
#aframeInspector .select__control {
  border: 0;
  border-radius: 0;
  cursor: pointer;
  min-height: 26px;
  font-family: system-ui, BlinkMacSystemFont, -apple-system, "Segoe UI", Helvetica, Arial, sans-serif;
  font-size: 13px;
}
#aframeInspector .select__indicator {
  height: 26px;
}
#aframeInspector .select__indicator-separator {
  display: none;
}
#aframeInspector .select__input {
  min-height: auto !important;
}
#aframeInspector .select__control,
#aframeInspector .select__menu {
  background: #1d1d1d;
}
#aframeInspector .select__option {
  padding: 5px 10px;
}
#aframeInspector .select__placeholder,
#aframeInspector .select__menu {
  color: #c3c3c3;
}
#aframeInspector .select__single-value {
  color: #1faaf2;
}
#aframeInspector .select__control--is-focused {
  box-shadow: none !important;
}
#aframeInspector .select__option {
  cursor: pointer;
}
#aframeInspector .select__label {
  font-size: 11px;
}
#aframeInspector .select__option--is-focused {
  background: #155373;
}
#aframeInspector .select__value-container {
  height: 26px;
  position: static;
}
#aframeInspector .select__value-container.select__value-container--is-multi {
  height: auto;
  padding: 6px;
}
#aframeInspector .select__dropdown-indicator {
  padding: 3px 8px;
}
#aframeInspector .select__multi-value {
  background: #242424;
  color: #1faaf2;
}
#aframeInspector .select__multi-value__label {
  color: #1faaf2;
}
#aframeInspector .select__multi-value__remove:hover {
  color: #fff;
  background: #242424;
}
#aframeInspector .modal {
  animation: animateopacity 0.2s ease-out;
  background-color: #000;
  background-color: rgba(0,0,0,0.6);
  display: flex;
  height: 100%;
  left: 0;
  overflow: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999999999;
}
#aframeInspector .modal h3 {
  font-size: 18px;
  font-weight: 100;
  margin: 0.6em 0;
}
#aframeInspector #textureModal .modal-content {
  height: calc(100% - 50px);
  width: calc(100% - 50px);
}
#aframeInspector .modal-content {
  animation: animatetop 0.2s ease-out;
  animation-duration: 0.2s;
  animation-name: animatetop;
  background-color: #232323;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.5), 0 6px 20px 0 rgba(0,0,0,0.5);
  margin: auto;
  overflow: hidden;
  padding: 0;
}
#aframeInspector .close {
  color: #fff;
  float: right;
  font-size: 28px;
  font-weight: bold;
}
#aframeInspector .close:hover,
#aframeInspector .close:focus {
  color: #08f;
  cursor: pointer;
  text-decoration: none;
}
#aframeInspector .modal-header {
  color: #fff;
  padding: 2px 16px;
}
#aframeInspector .modal-body {
  overflow: auto;
  padding: 16px;
}
#aframeInspector .modal-footer {
  color: #fff;
  padding: 2px 16px;
}
#aframeInspector .gallery {
  background: #232323;
  display: flex;
  flex-wrap: wrap;
  margin: 15px auto 0;
  max-height: calc(100vh - 370px);
  overflow: auto;
  padding: 15px 3px 3px;
}
#aframeInspector .newimage .gallery {
  padding: 16px;
}
#aframeInspector .gallery li {
  border-radius: 2px;
  box-shadow: 0 0 6px rgba(0,0,0,0.6);
  cursor: pointer;
  margin: 8px;
  overflow: hidden;
  width: 155px;
}
#aframeInspector .gallery li.selected,
#aframeInspector .gallery li:hover {
  box-shadow: 0 0 0 2px #1eaaf1;
}
#aframeInspector .gallery li .detail {
  background-color: #323232;
  margin: 0;
  min-height: 60px;
  padding: 3px 10px;
}
#aframeInspector .preview {
  padding: 10px;
  width: 150px;
}
#aframeInspector .preview input {
  display: block;
  margin: 8px 0;
  width: 144px;
}
#aframeInspector .preview button {
  width: 155px;
}
#aframeInspector .preview .detail .title {
  color: #fff;
  display: inline-block;
  max-width: 155px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#aframeInspector .gallery li.selected .detail,
#aframeInspector .gallery li:hover .detail {
  background-color: #444;
}
#aframeInspector .gallery li .detail span {
  color: #777;
  display: block;
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 140px;
}
#aframeInspector .gallery li.selected .detail span,
#aframeInspector .gallery li:hover .detail span {
  color: #888;
}
#aframeInspector .gallery li .detail span.title {
  color: #fff !important;
}
#aframeInspector .modal button {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-radius: 0;
  box-shadow: none;
  cursor: pointer;
  display: inline-block;
  font-size: 12px;
  line-height: 1.8;
  margin: 0 10px 0 0;
  padding: 5px 10px;
}
#aframeInspector .modal button:focus {
  outline: none;
}
#aframeInspector .modal button {
  background-color: #1eaaf1;
  border: none;
  color: #fff;
}
#aframeInspector .modal button:hover,
#aframeInspector .modal button.hover {
  background-color: #346392;
  text-shadow: -1px 1px #27496d;
}
#aframeInspector .modal button:active,
#aframeInspector .modal button.active {
  background-color: #27496d;
  text-shadow: -1px 1px #193047;
}
#aframeInspector .modal button:disabled {
  background-color: #888;
  cursor: none;
}
#aframeInspector .newimage {
  background-color: #323232;
  color: #bcbcbc;
  display: flex;
  font-size: 13px;
  justify-content: space-between;
  margin-top: 10px;
  overflow: auto;
  padding: 10px;
}
#aframeInspector .newimage input {
  color: #1eaaf1;
  padding: 3px 5px;
}
#aframeInspector .texture canvas + input {
  margin-left: 5px;
}
#aframeInspector .texture svg {
  padding-right: 5px;
}
#aframeInspector .uploader-normal-button .hidden {
  display: none;
}
#aframeInspector .assets.search {
  position: relative;
  margin-top: 10px;
  width: 200px;
}
#aframeInspector .assets.search svg {
  position: absolute;
  right: 0px;
  top: 5px;
}
#aframeInspector .new_asset_options {
  margin: 10px;
}
#aframeInspector .new_asset_options > ul {
  margin-left: 10px;
  padding: 5px;
}
#aframeInspector .new_asset_options > ul > li {
  padding: 10px 0;
}
#aframeInspector .new_asset_options .imageUrl {
  margin-left: 5px;
  width: 350px;
}
#aframeInspector .texture canvas {
  border: 1px solid #333;
  cursor: pointer;
}
#aframeInspector svg:not(:root).svg-inline--fa,
#aframeInspector svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}
#aframeInspector .svg-inline--fa {
  display: inline-block;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
#aframeInspector #viewportBar {
  align-items: center;
  background-color: #242424;
  color: #c3c3c3;
  display: flex;
  flex-grow: 2;
  height: 32px;
  font-size: 15px;
  justify-content: space-between;
  left: 0;
  margin: 0 auto;
  right: 0;
  top: 0;
}
#aframeInspector .toolbarButtons {
  display: flex;
  align-items: center;
  gap: 6px;
}
#aframeInspector .toolbarButtons * {
  margin-left: 0 !important;
  vertical-align: middle;
}
#aframeInspector .toolbarButtons a.button svg {
  padding: 8px;
}
#aframeInspector .toolbarButtons a.button:not(.active) svg:hover {
  background-color: #444;
}
#aframeInspector .toolbarButtons .active svg {
  background-color: #1faaf2;
  color: #fff;
}
#aframeInspector .toolbarButtons .active:hover svg {
  color: #fff !important;
}
#aframeInspector .local-transform {
  padding-left: 10px;
  padding-right: 20px;
}
#aframeInspector .local-transform label {
  color: #aaa;
  padding-left: 5px;
}
#aframeInspector .local-transform a.button {
  padding-top: 0;
}
#aframeInspector #cameraSelect {
  cursor: pointer;
  width: 120px;
}
#aframeInspector #cameraSelect .select__dropdown-indicator {
  padding-left: 3px;
  padding-right: 3px;
}
#aframeInspector #cameraToolbar {
  margin-left: 5px;
  align-items: center;
  display: flex;
}
#aframeInspector #cameraToolbar a {
  margin-right: 10px;
}
#aframeInspector #cameraToolbar .select__control {
  background: none;
}
#aframeInspector #cameraToolbar .select__single-value {
  color: #c3c3c3;
}
#aframeInspector #cameraToolbar .select__single-value:hover {
  color: #1faaf2;
}
#aframeInspector #viewportHud {
  display: none;
}
@media (min-width: 1024px) {
  #aframeInspector #viewportHud {
    display: block;
  }
}
#aframeInspector svg:not(:root).svg-inline--fa,
#aframeInspector svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}
#aframeInspector .svg-inline--fa {
  display: inline-block;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
#aframeInspector .Select-control {
  background-color: #222 !important;
  border: none;
  border-radius: 0;
  color: #1faaf2;
  font-family: \$monosapce;
}
#aframeInspector .Select-menu-outer {
  border: none;
}
#aframeInspector .Select-menu-outer .is-focused {
  background-color: #1faaf2 !important;
  color: #c3c3c3;
}
#aframeInspector .Select-option {
  background-color: #222 !important;
}
#aframeInspector .select-widget {
  display: inline-block;
  width: 157px;
}
#aframeInspector .Select-placeholder,
#aframeInspector .Select--single > .Select-control .Select-value {
  color: #1faaf2 !important;
}
#aframeInspector .Select-value-label {
  color: #1faaf2 !important;
}
#aframeInspector .Select,
#aframeInspector code,
#aframeInspector pre,
#aframeInspector input,
#aframeInspector textarea,
#aframeInspector select {
  font-family: system-ui, BlinkMacSystemFont, -apple-system, "Segoe UI", Helvetica, Arial, sans-serif;
  font-size: 13px;
}
#aframeInspector .wf-robotomono-n4-active .Select,
#aframeInspector .wf-robotomono-n4-active code,
#aframeInspector .wf-robotomono-n4-active pre,
#aframeInspector .wf-robotomono-n4-active input,
#aframeInspector .wf-robotomono-n4-active textarea,
#aframeInspector .wf-robotomono-n4-active select {
  font-family: Roboto Mono, Consolas, Andale Mono, Monaco, Courier New, monospace;
}
#aframeInspector hr {
  border: 0;
  border-top: 1px solid #ccc;
}
#aframeInspector a {
  cursor: pointer;
}
#aframeInspector button {
  position: relative;
}
#aframeInspector code {
  font-family: Consolas, Andale Mono, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace;
}
#aframeInspector textarea {
  -moz-tab-size: 4;
    -o-tab-size: 4;
       tab-size: 4;
  white-space: pre;
  word-wrap: normal;
}
#aframeInspector textarea.success {
  border-color: #8b8 !important;
}
#aframeInspector textarea.fail {
  background-color: rgba(255,0,0,0.05);
  border-color: #f00 !important;
}
#aframeInspector textarea,
#aframeInspector input {
  outline: none /* osx */;
}
#aframeInspector .gltfIcon img {
  box-sizing: content-box;
  display: inline;
  height: 20px;
  left: 5px;
  padding: 0 5px;
  position: relative;
  top: 4px;
  vertical-align: baseline;
  width: 20px;
}
#aframeInspector #scenegraph,
#aframeInspector #rightPanel {
  z-index: 9998;
}
#aframeInspector #sidebar,
#aframeInspector #scenegraph,
#aframeInspector .panel {
  cursor: default;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
#aframeInspector .toggle-edit {
  background-color: #92374d;
  box-sizing: content-box;
  color: #fafafa;
  font-size: 13px;
  left: 3px;
  line-height: 16px;
  margin: 0;
  padding: 6px 10px;
  position: fixed;
  text-align: center;
  text-decoration: none;
  top: 3px;
  width: 100px;
  z-index: 999999999;
}
#aframeInspector .toggle-edit:hover {
  background-color: #e42b5a;
}
#aframeInspector .try-editor-btn {
  background-color: #92374d;
  box-sizing: content-box;
  color: #fafafa;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  padding: 6px 10px;
  text-align: center;
  text-decoration: none;
  width: 200px;
  display: flex;
  gap: 5px;
  justify-content: center;
}
#aframeInspector .try-editor-btn:hover {
  background-color: #e42b5a;
  color: #fafafa;
}
#aframeInspector .sponsor-btn {
  background-color: #fff;
  box-sizing: content-box;
  color: #000;
  font-size: 13px;
  left: 127px;
  line-height: 16px;
  margin: 0;
  padding: 6px 10px;
  position: fixed;
  text-align: center;
  text-decoration: none;
  top: 3px;
  width: 80px;
  z-index: 999999999;
  display: flex;
  gap: 5px;
  justify-content: center;
}
#aframeInspector .sponsor-btn svg {
  fill: currentColor;
  color: #db61a2;
}
#aframeInspector .sponsor-btn:hover {
  background-color: #e42b5a;
  color: #fafafa;
}
#aframeInspector input {
  background-color: transparent;
  border: 1px solid #555;
  color: #fff;
}
#aframeInspector input,
#aframeInspector .texture canvas {
  transition: 0.1s background-color ease-in-out, 0.1s border-color ease-in-out, 0.1s color ease-in-out;
}
#aframeInspector input[type=text],
#aframeInspector input[type=number],
#aframeInspector input.string,
#aframeInspector input.number {
  min-height: 14px;
  outline: none;
}
#aframeInspector input[type="checkbox"] {
  -webkit-appearance: auto;
     -moz-appearance: auto;
          appearance: auto;
  cursor: pointer;
  margin: 0;
  height: 18px;
  width: 18px;
}
#aframeInspector input[type="checkbox"]:focus {
  box-shadow: none;
}
#aframeInspector input.number {
  background-color: transparent !important;
  border: 0;
  color: #2cb7ff !important;
  cursor: col-resize;
  font-size: 13px;
  padding: 2px;
}
#aframeInspector input.stringfocus,
#aframeInspector input.numberfocus {
  border: 1px solid #20b1fb;
  color: #fff;
  cursor: auto;
}
#aframeInspector input.error {
  border: 1px solid #a00;
}
#aframeInspector #sidebar {
  background: #242424;
  width: 331px;
}
#aframeInspector #sidebar * {
  vertical-align: middle;
}
#aframeInspector input,
#aframeInspector textarea,
#aframeInspector select {
  background: #222;
  border: 1px solid transparent;
  color: #888;
}
#aframeInspector select {
  background: #393939;
}
#aframeInspector input[type=color] {
  background-color: #333;
  border: 1px solid #111;
  height: 28px;
  cursor: pointer;
}
#aframeInspector input[type=color] {
  cursor: pointer;
  height: 25px;
  padding: 0;
  width: 50px;
}
#aframeInspector input[type=color]-webkit-color-swatch {
  border: 0 /* To remove the gray border. */;
}
#aframeInspector input[type=color]-webkit-color-swatch-wrapper {
  padding: 0 /* To remove the inner padding. */;
}
#aframeInspector input[type=color]-moz-color-swatch {
  border: 0;
}
#aframeInspector input[type=color]-moz-focus-inner {
  border: 0 /* To remove the inner border (specific to Firefox). */;
  padding: 0;
}
#aframeInspector .hidden {
  visibility: hidden;
}
#aframeInspector a.button {
  color: #bcbcbc;
  font-size: 16px;
  margin-left: 10px;
  text-decoration: none;
}
#aframeInspector a.button:hover {
  color: #1faaf2;
}
#aframeInspector .hide {
  display: none;
}
#aframeInspector .a-canvas.state-dragging {
  cursor: grabbing;
}
#aframeInspector #rightPanel {
  align-items: stretch;
  display: flex;
  justify-content: flex-end;
}
#aframeInspector #inspectorContainer {
  display: flex;
  justify-content: space-between;
  left: 0;
  height: 100%;
  pointer-events: none;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999999;
}
#aframeInspector #scenegraph,
#aframeInspector #viewportBar,
#aframeInspector #rightPanel {
  pointer-events: all;
}
#aframeInspector .aframe-inspector-opened a-scene .a-canvas {
  background-color: #191919;
  z-index: 9998;
}
#aframeInspector .toggle-sidebar {
  align-items: center;
  display: flex;
  height: 100%;
  position: absolute;
  z-index: 9998;
}
#aframeInspector .toggle-sidebar a {
  background-color: #262626;
  color: #bcbcbc;
  padding: 5px;
  z-index: 9998;
}
#aframeInspector .toggle-sidebar a.hover {
  background-color: #1faaf2;
  color: #fff;
}
#aframeInspector .toggle-sidebar.left {
  top: 0;
  left: 0;
}
#aframeInspector .toggle-sidebar.right {
  top: 0;
  right: 0;
}
@keyframes animateopacity {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/style/lib.styl","webpack://./src/style/index.styl","webpack://./src/style/scenegraph.styl","webpack://./src/style/components.styl","webpack://./src/style/entity.styl","webpack://./src/style/help.styl","webpack://./src/style/select.styl","webpack://./src/style/textureModal.styl","webpack://./src/style/viewport.styl","webpack://./src/style/widgets.styl"],"names":[],"mappings":"AA8BA;;EACE,iBAAU;EACV,uBAAY;AC5Bd;AD+BA;EACE,qBAAS;EACT,WAAQ;EACR,iBAAU;EACV,wBAAgB;AC7BlB;AARA;;;EAGE,wFAA8B;AAUhC;AARA;;;EAGE,wFAA8B;AAUhC;AARA;EACE,mBAAW;EACX,WAAM;EACN,eAAU;EACV,SAAO;EACP,gBAAS;AAUX;ADGA;;EACE,iBAAU;EACV,uBAAY;ACAd;ADGA;EACE,qBAAS;EACT,WAAQ;EACR,iBAAU;EACV,wBAAgB;ACDlB;ACpCA;EACE,yBAAiB;ADsCnB;ACpCE;EACE,gBAAQ;EACR,aAAQ;EACR,qBAAY;ADsChB;ACpCI;EACE,WAAM;EACN,eAAO;ADsCb;ACpCI;EACE,YAAU;EACV,mBAAc;EACd,iBAAW;ADsCjB;ACpCA;EACE,mBAAW;EACX,0BAAW;EACX,aAAQ;EACR,sBAAe;EACf,cAAS;EACT,iBAAY;EACZ,YAAM;ADsCR;ACpCE;EACE,mBAAW;EACX,eAAO;EACP,aAAQ;EACR,8BAAgB;EAChB,YAAQ;EACR,WAAM;EACN,mBAAY;ADsChB;ACpCI;EACE,mBAAW;ADsCjB;ACpCI;EACE,yBAAiB;EACjB,WAAM;ADsCZ;ACrCM;EACE,cAAM;ADuCd;ACtCM;EACE,eAAQ;ADwChB;ACpCQ;;;;EAIE,WAAM;ADsChB;ACnCQ;;;;EAIE,cAAM;ADqChB;ACnCE;EACE,cAAM;ADqCV;ACnCE;EACE,gBAAY;ADqChB;ACnCE;EACE,aAAQ;EACR,cAAO;ADqCX;ACnCI;EACE,WAAM;EACN,eAAU;EACV,gBAAY;ADqClB;ACnCE;EACE,WAAM;ADqCV;ACnCE;;EAEE,cAAM;ADqCV;ACnCE;EACE,cAAM;ADqCV;ACnCE;EACE,WAAM;ADqCV;ACnCE;EACE,WAAM;ADqCV;ACnCE;EACE,WAAM;EACN,qBAAQ;EACR,kBAAW;EACX,WAAM;ADqCV;ACnCE;EACE,WAAM;ADqCV;ACnCE;EACE,WAAM;ADqCV;ACnCE;EACE,YAAQ;EACR,eAAU;EACV,kBAAS;ADqCb;ACnCI;EACE,cAAM;EACN,mBAAW;EACX,kBAAc;EACd,YAAO;EACP,iBAAY;EACZ,YAAM;ADqCZ;ACnCI;;EACE,kBAAS;EACT,WAAM;EACN,SAAI;ADsCV;ACpCE;EACE,mBAAW;EACX,cAAM;EACN,eAAO;EACP,cAAK;EACL,eAAU;EACV,yBAAO;EACP,mBAAY;EACZ,aAAQ;EACR,gBAAW;EACX,UAAQ;EACR,YAAM;ADsCV;ACpCA;EACE,yBAAiB;EACjB,0BAAW;EACX,UAAO;EACP,YAAO;EACP,OAAK;EACL,YAAQ;ADsCV;ACpCE;EACE,YAAM;EACN,YAAO;ADsCX;AD3JA;;EACE,iBAAU;EACV,uBAAY;AC8Jd;AD3JA;EACE,qBAAS;EACT,WAAQ;EACR,iBAAU;EACV,wBAAgB;AC6JlB;AE5LA;EACE,yBAAiB;EACjB,cAAM;EACN,YAAO;EACP,cAAS;EACT,eAAS;EACT,YAAM;AF8LR;AE5LA;;;EAGE,eAAQ;AF8LV;AE5LA;;EAEE,WAAM;AF8LR;AE5LA;EACE,WAAM;AF8LR;AE5LA;EACE,mBAAY;EACZ,aAAQ;EACR,8BAAgB;AF8LlB;AE7LE;EACE,WAAM;AF+LV;AE7LA;EACE,cAAQ;AF+LV;AE7LA;EACE,gBAAU;EACV,gBAAS;EACT,uBAAc;EACd,yBAAe;EACf,mBAAY;EACZ,WAAM;EACN,gBAAY;EACZ,iCAAe;AF+LjB;AE7LA;EACE,gBAAW;EACX,gCAAc;EACd,uBAAW;EACX,eAAO;EACP,YAAO;EACP,2BAAQ;EACR,sBAAe;EACf,eAAU;AF+LZ;AE9LE;EACE,mBAAW;AFgMf;AErLA;EACE,iBAAW;AFuLb;AErLA;EACE,WAAM;EACN,gBAAQ;EACR,eAAU;EACV,YAAQ;EACR,iBAAW;AFuLb;AErLA;EACE,SAAO;AFuLT;AErLA;EACE,6BAAO;EACP,WAAM;EACN,SAAO;EACP,kBAAa;EACb,gBAAY;EACZ,QAAM;AFuLR;AErLA;EACE,0BAAkB;EAClB,eAAW;AFuLb;AErLA;EACE,yBAAiB;EACjB,eAAW;AFuLb;AErLA;EACE,mBAAY;EACZ,aAAQ;EACR,eAAU;EACV,gBAAW;EACX,iBAAQ;AFuLV;AErLE;EACE,eAAO;EACP,qBAAQ;EACR,gBAAS;EACT,mBAAc;EACd,uBAAc;EACd,sBAAe;EACf,YAAM;AFuLV;AErLE;EACE,iBAAO;EACP,WAAM;AFuLV;AErLE;EACE,eAAU;EACV,YAAO;AFuLX;AErLE;;EAEE,iBAAY;AFuLhB;AErLE;EACE,YAAO;AFuLX;AErLE;;;;EAIE,mBAAW;EACX,cAAM;EACN,gBAAW;EACX,mBAAe;EACf,iBAAa;EACb,kBAAc;EACd,gBAAY;AFuLhB;AEtLI;;;;EACE,gBAAc;AF2LpB;AEzLE;EACE,iBAAa;EACb,sBAAW;EACX,YAAM;AF2LV;AEzLE;;EAEE,gBAAW;AF2Lf;AEzLE;EACE,iBAAO;EACP,WAAM;EACN,mBAAe;AF2LnB;AEzLA;EACE,cAAM;EACN,gBAAY;AF2Ld;AEzLA;EACE,sBAAe;AF2LjB;AEzLA;EACE,WAAM;EACN,sBAAM;EACN,iBAAY;EACZ,8BAAe;AF2LjB;AEzLA;EACE,mBAAY;EACZ,aAAQ;EACR,sBAAe;EACf,uBAAgB;EAChB,kBAAQ;EACR,mBAAW;AF2Lb;AEzLE;EACE,gBAAW;EACX,YAAM;AF2LV;AE1LI;EACE,mBAAW;EACX,YAAO;EACP,cAAM;AF4LZ;AE1LE;EACE,eAAU;EACV,oBAAO;AF4LX;AE1LE;EACE,gBAAW;AF4Lf;AE1LA;EACE,WAAM;AF4LR;AE1LA;EACE,mBAAY;EACZ,aAAQ;AF4LV;AEzLE;EACE,WAAO;EACP,kBAAS;AF2Lb;AE1LE;EACE,aAAQ;AF4LZ;AE3LE;EACE,YAAO;AF6LX;AE5LE;EACE,eAAU;EACV,iBAAa;AF8LjB;AE7LE;EACE,gBAAU;EACV,MAAI;AF+LR;AE9LE;EACE,cAAM;AFgMV;AE9LA;EACE,YAAM;AFgMR;AE9LA;EACE,aAAQ;AFgMV;AE/LE;EACE,cAAY;EACZ,YAAM;AFiMV;AE/LA;EACE,MAAI;AFiMN;ADtYA;;EACE,iBAAU;EACV,uBAAY;ACyYd;ADtYA;EACE,qBAAS;EACT,WAAQ;EACR,iBAAU;EACV,wBAAgB;ACwYlB;AG7aA;EACE,mGAAY;EACZ,mBAAY;AH+ad;AG7aA;EACE,qBAAQ;EACR,gBAAS;EACT,kBAAS;EACT,uBAAc;EACd,QAAI;EACJ,mBAAY;AH+ad;AG7aA;EACE,cAAM;AH+aR;AG7aA;EACE,cAAM;AH+aR;AG7aA;EACE,cAAM;AH+aR;AIpcA;EACE,aAAQ;EACR,6BAAgB;AJsclB;AIpcA;EACE,gBAAW;EACX,SAAO;EACP,iBAAQ;EACR,YAAM;AJscR;AIpcA;EACE,kBAAa;AJscf;AIpcA;EACE,gBAAY;EACZ,iBAAa;EACb,cAAQ;AJscV;AIpcA;EACE,WAAO;EACP,iBAAa;EACb,eAAU;EACV,kBAAS;AJscX;AIpcA;EACE,yBAAiB;EACjB,2BAAkB;EAClB,sBAAO;EACP,kBAAc;EACd,wBAAW;EACX,WAAM;EACN,qBAAQ;EACR,eAAU;EACV,cAAQ;EACR,kBAAW;AJscb;AIpcA;EACE,WAAM;EACN,qBAAQ;EACR,gBAAY;AJscd;AD/cA;;EACE,iBAAU;EACV,uBAAY;ACkdd;AD/cA;EACE,qBAAS;EACT,WAAQ;EACR,iBAAU;EACV,wBAAgB;ACidlB;AKtfA;EACE,SAAO;EACP,gBAAc;EACd,eAAO;EACP,gBAAW;EACX,mGAAY;EACZ,eAAU;ALwfZ;AKtfA;EACE,YAAO;ALwfT;AKtfA;EACE,aAAQ;ALwfV;AKtfA;EACE,2BAAW;ALwfb;AKtfA;;EAEE,mBAAW;ALwfb;AKtfA;EACE,iBAAQ;ALwfV;AKtfA;;EAEE,cAAM;ALwfR;AKtfA;EACE,cAAM;ALwfR;AKtfA;EACE,2BAAW;ALwfb;AKtfA;EACE,eAAO;ALwfT;AKtfA;EACE,eAAU;ALwfZ;AKtfA;EACE,mBAAW;ALwfb;AKtfA;EACE,YAAO;EACP,gBAAS;ALwfX;AKvfE;EACE,YAAO;EACP,YAAQ;ALyfZ;AKvfA;EACE,gBAAQ;ALyfV;AKvfA;EACE,mBAAW;EACX,cAAM;ALyfR;AKvfA;EACE,cAAM;ALyfR;AKvfA;EACE,WAAM;EACN,mBAAW;ALyfb;AMzjBA;EACE,uCAAU;EACV,sBAAiB;EACjB,iCAAiB;EACjB,aAAQ;EACR,YAAO;EACP,OAAK;EACL,cAAS;EACT,eAAS;EACT,MAAI;EACJ,WAAM;EACN,mBAAQ;AN2jBV;AMzjBA;EACE,eAAU;EACV,gBAAY;EACZ,eAAO;AN2jBT;AMzjBA;EACE,yBAAO;EACP,wBAAM;AN2jBR;AMzjBA;EACE,mCAAU;EACV,wBAAmB;EACnB,0BAAe;EACf,yBAAiB;EACjB,qEAAyC;EACzC,YAAO;EACP,gBAAS;EACT,UAAQ;AN2jBV;AMzjBA;EACE,WAAM;EACN,YAAM;EACN,eAAU;EACV,iBAAY;AN2jBd;AMzjBA;;EAEE,WAAM;EACN,eAAO;EACP,qBAAgB;AN2jBlB;AMzjBA;EACE,WAAM;EACN,iBAAQ;AN2jBV;AMzjBA;EACE,cAAS;EACT,aAAQ;AN2jBV;AMzjBA;EACE,WAAM;EACN,iBAAQ;AN2jBV;AMxjBA;EACE,mBAAW;EACX,aAAQ;EACR,eAAU;EACV,mBAAO;EACP,+BAAW;EACX,cAAS;EACT,qBAAQ;AN0jBV;AMxjBA;EACE,aAAQ;AN0jBV;AMxjBA;EACE,kBAAc;EACd,mCAAW;EACX,eAAO;EACP,WAAO;EACP,gBAAS;EACT,YAAM;AN0jBR;AMxjBA;;EAEE,6BAAW;AN0jBb;AMxjBA;EACE,yBAAiB;EACjB,SAAO;EACP,gBAAW;EACX,iBAAQ;AN0jBV;AMxjBA;EACE,aAAQ;EACR,YAAM;AN0jBR;AMxjBA;EACE,cAAQ;EACR,aAAO;EACP,YAAM;AN0jBR;AMxjBA;EACE,YAAM;AN0jBR;AMxjBA;EACE,WAAM;EACN,qBAAQ;EACR,gBAAU;EACV,gBAAS;EACT,uBAAc;EACd,mBAAY;AN0jBd;AMxjBA;;EAEE,sBAAiB;AN0jBnB;AMxjBA;EACE,WAAM;EACN,cAAQ;EACR,eAAW;EACX,gBAAS;EACT,uBAAc;EACd,mBAAY;EACZ,YAAM;AN0jBR;AMxjBA;;EAEE,WAAM;AN0jBR;AMxjBA;EACE,sBAAM;AN0jBR;AMxjBA;EACE,wBAAW;KAAX,qBAAW;UAAX,gBAAW;EACX,gBAAc;EACd,gBAAW;EACX,eAAO;EACP,qBAAQ;EACR,eAAU;EACV,gBAAY;EACZ,kBAAO;EACP,iBAAQ;AN0jBV;AMxjBA;EACE,aAAQ;AN0jBV;AMxjBA;EACE,yBAAiB;EACjB,YAAO;EACP,WAAM;AN0jBR;AMxjBA;;EAEE,yBAAiB;EACjB,6BAAY;AN0jBd;AMxjBA;;EAEE,yBAAiB;EACjB,6BAAY;AN0jBd;AMxjBA;EACE,sBAAiB;EACjB,YAAO;AN0jBT;AMxjBA;EACE,yBAAiB;EACjB,cAAM;EACN,aAAQ;EACR,eAAU;EACV,8BAAgB;EAChB,gBAAW;EACX,cAAS;EACT,aAAQ;AN0jBV;AMxjBA;EACE,cAAM;EACN,gBAAQ;AN0jBV;AMxjBA;EACE,gBAAY;AN0jBd;AMxjBA;EACE,kBAAc;AN0jBhB;AMxjBA;EACE,aAAQ;AN0jBV;AMxjBA;EACE,kBAAS;EACT,gBAAW;EACX,YAAM;AN0jBR;AMxjBA;EACE,kBAAS;EACT,UAAM;EACN,QAAI;AN0jBN;AMxjBA;EACE,YAAO;AN0jBT;AMxjBA;EACE,iBAAY;EACZ,YAAQ;AN0jBV;AMxjBA;EACE,eAAQ;AN0jBV;AMxjBA;EACE,gBAAY;EACZ,YAAM;AN0jBR;AMxjBA;EACE,sBAAO;EACP,eAAO;AN0jBT;AD7uBA;;EACE,iBAAU;EACV,uBAAY;ACgvBd;AD7uBA;EACE,qBAAS;EACT,WAAQ;EACR,iBAAU;EACV,wBAAgB;AC+uBlB;AOpxBA;EACE,mBAAY;EACZ,yBAAiB;EACjB,cAAM;EACN,aAAQ;EACR,YAAU;EACV,YAAO;EACP,eAAU;EACV,8BAAgB;EAChB,OAAK;EACL,cAAO;EACP,QAAM;EACN,MAAI;APsxBN;AOpxBA;EACE,aAAQ;EACR,mBAAY;EACZ,QAAI;APsxBN;AOpxBE;EACE,yBAAY;EACZ,sBAAe;APsxBnB;AOnxBI;EACE,YAAQ;APqxBd;AOnxBI;EACE,sBAAiB;APqxBvB;AOnxBE;EACE,yBAAiB;EACjB,WAAM;APqxBV;AOnxBE;EACE,sBAAM;APqxBV;AOnxBA;EACE,kBAAa;EACb,mBAAc;APqxBhB;AOnxBA;EACE,WAAM;EACN,iBAAa;APqxBf;AOnxBA;EACE,cAAY;APqxBd;AOnxBA;EACE,eAAO;EACP,YAAM;APqxBR;AOpxBE;EACE,iBAAa;EACb,kBAAc;APsxBlB;AOpxBA;EACE,gBAAY;EACZ,mBAAY;EACZ,aAAQ;APsxBV;AOrxBE;EACE,kBAAa;APuxBjB;AOtxBE;EACE,gBAAW;APwxBf;AOvxBE;EACE,cAAM;APyxBV;AOxxBI;EACE,cAAM;AP0xBZ;AOxxBA;EACE,aAAQ;AP0xBV;ADz0B2B;EAAA;IQiDvB,cAAQ;EP4xBV;AACF;ADx0BA;;EACE,iBAAU;EACV,uBAAY;AC20Bd;ADx0BA;EACE,qBAAS;EACT,WAAQ;EACR,iBAAU;EACV,wBAAgB;AC00BlB;AQ/2BA;EACE,iCAAiB;EACjB,YAAO;EACP,gBAAc;EACd,cAAM;EACN,uBAAY;ARi3Bd;AQ/2BA;EACE,YAAO;ARi3BT;AQ/2BA;EACE,oCAAiB;EACjB,cAAM;ARi3BR;AQ/2BA;EACE,iCAAiB;ARi3BnB;AQ/2BA;EACE,qBAAQ;EACR,YAAM;ARi3BR;AQ/2BA;;EAEE,yBAAM;ARi3BR;AQ/2BA;EACE,yBAAM;ARi3BR;AAh3BE;;;;;;EAME,mGAAY;EACZ,eAAU;AAk3Bd;AAh3BE;;;;;;EAME,+EAAuB;AAk3B3B;AAh3BE;EACE,SAAO;EACP,0BAAW;AAk3Bf;AAh3BE;EACE,eAAO;AAk3BX;AAh3BE;EACE,kBAAS;AAk3Bb;AAh3BE;EACE,+IAAoB;AAk3BxB;AAh3BE;EACE,gBAAS;IAAT,cAAS;OAAT,WAAS;EACT,gBAAY;EACZ,iBAAU;AAk3Bd;AAh3BE;EACE,6BAAa;AAk3BjB;AAh3BE;EACE,oCAAiB;EACjB,6BAAa;AAk3BjB;AAh3BE;;EAEE,uBAAQ;AAk3BZ;AAh3BE;EACE,uBAAW;EACX,eAAQ;EACR,YAAO;EACP,SAAK;EACL,cAAQ;EACR,kBAAS;EACT,QAAI;EACJ,wBAAe;EACf,WAAM;AAk3BV;AAh3BE;;EAEE,aAAQ;AAk3BZ;AAh3BE;;;EAGI,eAAO;EACP,yBAAY;KAAZ,sBAAY;UAAZ,iBAAY;AAk3BlB;AAh3BE;EACE,yBAAiB;EACjB,uBAAW;EACX,cAAM;EACN,eAAU;EACV,SAAK;EACL,iBAAY;EACZ,SAAO;EACP,iBAAQ;EACR,eAAS;EACT,kBAAW;EACX,qBAAgB;EAChB,QAAI;EACJ,YAAM;EACN,kBAAQ;AAk3BZ;AAh3BE;EACE,yBAAiB;AAk3BrB;AAh3BE;EACE,yBAAiB;EACjB,uBAAW;EACX,cAAM;EACN,eAAU;EACV,iBAAY;EACZ,SAAO;EACP,iBAAQ;EACR,kBAAW;EACX,qBAAgB;EAChB,YAAM;EACN,aAAQ;EACR,QAAI;EACJ,uBAAgB;AAk3BpB;AAh3BE;EACE,yBAAiB;EACjB,cAAM;AAk3BV;AAh3BE;EACE,sBAAiB;EACjB,uBAAW;EACX,WAAM;EACN,eAAU;EACV,WAAK;EACL,iBAAY;EACZ,SAAO;EACP,iBAAQ;EACR,eAAS;EACT,kBAAW;EACX,qBAAgB;EAChB,QAAI;EACJ,WAAM;EACN,kBAAQ;EACR,aAAQ;EACR,QAAI;EACJ,uBAAgB;AAk3BpB;AAh3BI;EACE,kBAAK;EACL,cAAM;AAk3BZ;AAh3BE;EACE,yBAAiB;EACjB,cAAM;AAk3BV;AAh3BE;EACE,6BAAiB;EACjB,sBAAO;EACP,WAAM;AAk3BV;AAh3BE;;EAEE,oGAA4C;AAk3BhD;AAh3BE;;;;EAIE,gBAAW;EACX,aAAQ;AAk3BZ;AAh3BE;EACE,wBAAW;KAAX,qBAAW;UAAX,gBAAW;EACX,eAAO;EACP,SAAO;EACP,YAAO;EACP,WAAM;AAk3BV;AAh3BE;EACE,gBAAW;AAk3Bf;AAh3BE;EACE,wCAAiB;EACjB,SAAO;EACP,yBAAM;EACN,kBAAO;EACP,eAAU;EACV,YAAQ;AAk3BZ;AAh3BE;;EAEE,yBAAO;EACP,WAAM;EACN,YAAO;AAk3BX;AAh3BE;EACE,sBAAO;AAk3BX;AAh3BE;EACE,mBAAW;EACX,YAAM;AAk3BV;AAh3BE;EACE,sBAAe;AAk3BnB;AAh3BE;;;EAGE,gBAAW;EACX,6BAAO;EACP,WAAM;AAk3BV;AAh3BE;EACE,mBAAW;AAk3Bf;AAh3BE;EACE,sBAAiB;EACjB,sBAAO;EACP,YAAO;EACP,eAAO;AAk3BX;AAh3BE;EACE,eAAO;EACP,YAAO;EACP,UAAQ;EACR,WAAM;AAk3BV;AA/2BE;EACE,0CAAO;AAi3BX;AA/2BE;EACE,6CAAQ;AAi3BZ;AA/2BE;EACE,SAAO;AAi3BX;AA/2BE;EACE,iEAAO;EACP,UAAQ;AAi3BZ;AA/2BE;EACE,kBAAW;AAi3Bf;AA/2BE;EACE,cAAM;EACN,eAAU;EACV,iBAAY;EACZ,qBAAgB;AAi3BpB;AA/2BI;EACE,cAAM;AAi3BZ;AA32BE;EACE,aAAQ;AA62BZ;AA32BE;EACE,gBAAO;AA62BX;AA32BE;EACE,oBAAY;EACZ,aAAQ;EACR,yBAAgB;AA62BpB;AA32BE;EACE,aAAQ;EACR,8BAAgB;EAChB,OAAK;EACL,YAAO;EACP,oBAAe;EACf,eAAS;EACT,MAAI;EACJ,WAAM;EACN,eAAQ;AA62BZ;AA32BE;;;EAGE,mBAAe;AA62BnB;AA32BE;EACE,yBAAiB;EACjB,aAAQ;AA62BZ;AA32BE;EACE,mBAAY;EACZ,aAAQ;EACR,YAAO;EACP,kBAAS;EACT,aAAQ;AA62BZ;AA32BI;EACE,yBAAiB;EACjB,cAAM;EACN,YAAQ;EACR,aAAQ;AA62Bd;AA32BI;EACE,yBAAiB;EACjB,WAAM;AA62BZ;AA32BE;EACE,MAAI;EACJ,OAAK;AA62BT;AA32BE;EACE,MAAI;EACJ,QAAM;AA62BV;AAv6BE;EACE;IAAO,UAAS;EAk8BlB;EAj8BE;IAAK,UAAS;EAo8BhB;AACF","sourcesContent":["$primary=#1faaf2\n$primaryhover=lighten(#1faaf2, 35%)\n\n$bg=#242424\n$bgdark=#1d1d1d\n$bglight=#333\n$bglighter=#393939\n\n$red=#92374d\n$green=#514b23\n$orange=#d66853\n\n$black=#222\n$gray=#262626\n$grayalt=#323232\n$grayhover=#444\n\n$lightgray=#AAA\n$white=#c3c3c3\n\n$normalfont=system-ui, BlinkMacSystemFont, -apple-system, \"Segoe UI\", Helvetica, Arial, sans-serif\n$monospace=system-ui, BlinkMacSystemFont, -apple-system, \"Segoe UI\", Helvetica, Arial, sans-serif\n\nmedia--1024() {\n  @media (min-width: 1024px) {\n    {block}\n  }\n}\n\n/* CSS rules from the original FontAwesomeIcon component */\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}","@import './lib';\n\nbody.aframe-inspector-opened,\n.toggle-edit,\n.sponsor-btn\n  font-family BlinkMacSystemFont, -apple-system, \"Segoe UI\", Helvetica, Arial, sans-serif\n\n.wf-roboto-n4-active body.aframe-inspector-opened,\n.wf-roboto-n4-active .toggle-edit,\n.wf-roboto-n4-active .sponsor-btn\n  font-family BlinkMacSystemFont, -apple-system, \"Segoe UI\", Helvetica, Arial, sans-serif\n\nbody.aframe-inspector-opened\n  background $bgdark\n  color #fff\n  font-size 12px\n  margin 0\n  overflow hidden\n\n#aframeInspector\n  @import './scenegraph';\n  @import './components';\n  @import './entity';\n  @import './help';\n  @import './select';\n  @import './textureModal';\n  @import './viewport';\n  @import './widgets';\n\n  .Select,\n  code,\n  pre,\n  input,\n  textarea,\n  select\n    font-family $monospace\n    font-size 13px\n\n  .wf-robotomono-n4-active .Select,\n  .wf-robotomono-n4-active code,\n  .wf-robotomono-n4-active pre,\n  .wf-robotomono-n4-active input,\n  .wf-robotomono-n4-active textarea,\n  .wf-robotomono-n4-active select\n    font-family Roboto Mono, Consolas, Andale Mono, Monaco, Courier New, monospace\n\n  hr\n    border 0\n    border-top 1px solid #ccc\n\n  a\n    cursor pointer\n\n  button\n    position relative\n\n  code\n    font-family Consolas, Andale Mono, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace\n\n  textarea\n    tab-size 4\n    white-space pre\n    word-wrap normal\n\n  textarea.success\n    border-color #8b8 !important\n\n  textarea.fail\n    background-color rgba(255, 0, 0, 0.05)\n    border-color #f00 !important\n\n  textarea,\n  input\n    outline none /* osx */\n\n  .gltfIcon img\n    box-sizing content-box\n    display inline\n    height 20px\n    left 5px\n    padding 0 5px\n    position relative\n    top 4px\n    vertical-align baseline\n    width 20px\n\n  #scenegraph,\n  #rightPanel\n    z-index 9998\n\n  #sidebar,\n  #scenegraph,\n    .panel\n      cursor default\n      user-select none\n\n  .toggle-edit\n    background-color $red\n    box-sizing content-box\n    color #FAFAFA\n    font-size 13px\n    left 3px\n    line-height 16px\n    margin 0\n    padding 6px 10px\n    position fixed\n    text-align center\n    text-decoration none\n    top 3px\n    width 100px\n    z-index 999999999\n\n  .toggle-edit:hover\n    background-color rgb(228, 43, 90)\n\n  .try-editor-btn\n    background-color $red\n    box-sizing content-box\n    color #FAFAFA\n    font-size 16px\n    line-height 24px\n    margin 0\n    padding 6px 10px\n    text-align center\n    text-decoration none\n    width 200px\n    display flex\n    gap 5px\n    justify-content center\n\n  .try-editor-btn:hover\n    background-color rgb(228, 43, 90)\n    color #FAFAFA\n\n  .sponsor-btn\n    background-color #ffffff\n    box-sizing content-box\n    color #000000\n    font-size 13px\n    left 127px\n    line-height 16px\n    margin 0\n    padding 6px 10px\n    position fixed\n    text-align center\n    text-decoration none\n    top 3px\n    width 80px\n    z-index 999999999\n    display flex\n    gap 5px\n    justify-content center\n\n    svg\n      fill currentColor\n      color rgb(219, 97, 162)\n\n  .sponsor-btn:hover\n    background-color rgb(228, 43, 90)\n    color #FAFAFA\n\n  input\n    background-color transparent\n    border 1px solid #555\n    color #fff\n\n  input,\n  .texture canvas\n    transition 0.1s background-color ease-in-out, 0.1s border-color ease-in-out, 0.1s color ease-in-out\n\n  input[type=text],\n  input[type=number],\n  input.string,\n  input.number\n    min-height 14px\n    outline none\n\n  input[type=\"checkbox\"]\n    appearance auto\n    cursor pointer\n    margin 0\n    height 18px\n    width 18px\n\n  input[type=\"checkbox\"]:focus\n    box-shadow none\n\n  input.number\n    background-color transparent !important\n    border 0\n    color #2cb7ff !important\n    cursor col-resize\n    font-size 13px\n    padding 2px\n\n  input.stringfocus,\n  input.numberfocus\n    border 1px solid #20b1fb\n    color #fff\n    cursor auto\n\n  input.error\n    border 1px solid #a00\n\n  #sidebar\n    background $bg\n    width 331px\n\n  #sidebar *\n    vertical-align middle\n\n  input,\n  textarea,\n  select\n    background $black\n    border 1px solid transparent\n    color #888\n\n  select\n    background $bglighter\n\n  input[type=color]\n    background-color #333\n    border 1px solid #111\n    height 28px\n    cursor pointer\n\n  input[type=color]\n    cursor pointer\n    height 25px\n    padding 0\n    width 50px\n\n  /* Note these vendor-prefixed selectors cannot be grouped! */\n  input[type=color]-webkit-color-swatch\n    border 0  /* To remove the gray border. */\n\n  input[type=color]-webkit-color-swatch-wrapper\n    padding 0  /* To remove the inner padding. */\n\n  input[type=color]-moz-color-swatch\n    border 0\n\n  input[type=color]-moz-focus-inner\n    border 0  /* To remove the inner border (specific to Firefox). */\n    padding 0\n\n  .hidden\n    visibility hidden\n\n  a.button\n    color #bcbcbc\n    font-size 16px\n    margin-left 10px\n    text-decoration none\n\n    &:hover\n      color $primary\n\n  @keyframes animateopacity\n    from { opacity: 0 }\n    to { opacity: 1 }\n\n  .hide\n    display none\n\n  .a-canvas.state-dragging\n    cursor grabbing\n\n  #rightPanel\n    align-items stretch\n    display flex\n    justify-content flex-end\n\n  #inspectorContainer\n    display flex\n    justify-content space-between\n    left 0\n    height 100%\n    pointer-events none\n    position fixed\n    top 0\n    width 100%\n    z-index 999999\n\n  #scenegraph,\n  #viewportBar,\n  #rightPanel\n    pointer-events all\n\n  .aframe-inspector-opened a-scene .a-canvas\n    background-color #191919\n    z-index 9998\n\n  .toggle-sidebar\n    align-items center\n    display flex\n    height 100%\n    position absolute\n    z-index 9998\n\n    a\n      background-color #262626\n      color #bcbcbc\n      padding 5px\n      z-index 9998\n\n    a.hover\n      background-color #1faaf2\n      color #fff\n\n  .toggle-sidebar.left\n    top 0\n    left 0\n\n  .toggle-sidebar.right\n    top 0\n    right 0\n","@import './lib';\n\n#toolbar\n  background-color $bg\n\n  .toolbarActions\n    padding 0 0 5px\n    display flex\n    align-items baseline\n\n    a.disabled\n      color #666\n      cursor default\n\n    .helpButtonContainer\n      flex-grow 1\n      padding-right 10px\n      text-align right\n\n#scenegraph\n  background $bg\n  border-top 1px solid #111\n  display flex\n  flex-direction column\n  overflow auto\n  padding-top 32px\n  width 230px\n\n  .entity\n    background $bg\n    cursor pointer\n    display flex\n    justify-content space-between\n    padding 3px\n    width 100%\n    white-space nowrap\n\n    &:hover\n      background #1d2f39\n\n    &.active\n      background-color #155373\n      color #fff\n      .component:hover\n        color #1888c1\n      .entityActions\n        display inline\n\n    &.novisible\n      &.active\n        span,\n        svg,\n        .collapsespace,\n        .id\n          color #999\n\n      &:not(.active)\n        span,\n        svg,\n        .collapsespace,\n        .id\n          color #626262\n\n  .component:hover\n    color #1faaf2\n\n  .entityIcons\n    margin-left 2px\n\n  .entityActions\n    display none\n    margin 0 14px\n\n    .button\n      color #fff\n      font-size 12px\n      margin-left 6px\n\n  svg\n    color #CCC\n\n  .toolbarActions svg:hover,\n  .entityActions svg:hover\n    color $primary\n\n  .active svg\n    color #FAFAFA\n\n  .id\n    color #ccc\n\n  .option.active .id\n    color #fff\n\n  .collapsespace\n    color #eee\n    display inline-block\n    text-align center\n    width 14px\n\n  .fa-eye\n    color #bbb\n\n  .icons a.button\n    color #fff\n\n  .search\n    padding 5px\n    font-size 16px\n    position relative\n\n    input\n      color $white\n      background $bgdark\n      border-radius 5px\n      height 22px\n      text-indent 10px\n      width 216px\n\n    >svg, a.button\n      position absolute\n      right 14px\n      top 10px\n\n  .outliner\n    background $bg\n    color $white\n    cursor default\n    flex 1 1 auto\n    font-size 13px\n    height calc(100% - 98px)\n    line-height normal\n    outline none\n    overflow-y auto\n    padding 0\n    width 230px\n\n.scenegraph-bottom\n  background-color #323232\n  border-top 1px solid #111\n  bottom 10\n  height 40px\n  left 0\n  z-index 100\n\n  a\n    float right\n    margin 10px\n","@import './lib';\n\npropertyRowDefined() {\n  .propertyRowDefined {\n    {block}\n  }\n}\n\n.components\n  background-color $bg\n  color $white\n  height 100%\n  overflow auto\n  position fixed\n  width 331px\n\ndiv.vec2,\ndiv.vec3,\ndiv.vec4\n  display inline\n\n.vec2 input.number,\n.vec3 input.number\n  width 40px\n\n.vec4 input.number\n  width 34px\n\n.collapsible-header\n  align-items center\n  display flex\n  justify-content space-between\n  .entityPrint\n    color #fff\n\n.collapsible-content\n  padding 5px 0\n\n.componentTitle span\n  max-width 200px\n  overflow hidden\n  text-overflow ellipsis\n  text-transform uppercase\n  white-space nowrap\n  color #fff\n  font-weight 600\n  vertical-align bottom !important\n\n.collapsible .static\n  background $bglight\n  border-bottom 2px solid $bg\n  box-sizing content-box\n  cursor pointer\n  height 16px\n  padding 8px 10px 12px 10px\n  vertical-align bottom\n  font-size 13px\n  &:hover\n    background $bglighter\n/*\n.collapsible\n  &.collapsed\n    background-color $grayalt\n    .static,\n    .componentHeaderActions\n      color #dedede\n    &:hover\n      background-color $grayhover\n*/\n.collapsible .menu\n  text-align right\n\n.collapsible .menuafter\n  color #bbb\n  content '\\2807'\n  font-size 12px\n  padding 5px\n  text-align right\n\n.collapsible .static\n  margin 0\n\n.collapsible .static .collapse-button\n  border 6px solid transparent\n  float left\n  height 0\n  margin-right 10px\n  margin-left 2px\n  width 0\n\n.collapsible.collapsed .static .collapse-button\n  border-left-color $white\n  margin-top 4px\n\n.collapsible:not(.collapsed) .static .collapse-button\n  border-top-color $white\n  margin-top 7px\n\n.propertyRow\n  align-items center\n  display flex\n  font-size 13px\n  min-height 30px\n  padding 2px 15px\n\n  .text\n    cursor default\n    display inline-block\n    overflow hidden\n    padding-right 10px\n    text-overflow ellipsis\n    vertical-align middle\n    width 118px\n\n  .map_value\n    margin 0 0 0 5px\n    width 68px\n\n  .Select-control\n    font-size 11px\n    height 24px\n\n  .Select-placeholder,\n  .Select--single > .Select-control .Select-value\n    line-height 19px\n\n  .Select-input\n    height 22px\n\n  input[type=text],\n  input[type=number],\n  input.string,\n  input.number\n    background $bgdark\n    color #1faaf2\n    min-height 26px\n    padding-bottom 1px\n    padding-left 5px\n    padding-right 5px\n    padding-top 1px\n    &:last-child\n      padding-right 0\n\n  input.string\n    padding-left 8px\n    box-sizing border-box\n    width 165px\n\n  input[type=text]:focus,\n  input.string:focus\n    box-shadow none\n\n  .color_value\n    margin 0 0 0 5px\n    width 68px\n    letter-spacing 1px\n\n.propertyRowDefined .text\n  color #FAFAFA\n  font-weight 500\n\n.components *\n  vertical-align middle\n\nspan.subcomponent\n  color #999\n  float none !important\n  margin-left 10px\n  vertical-align top !important\n\n#addComponentContainer\n  align-items center\n  display flex\n  flex-direction column\n  justify-content center\n  padding 20px 10px\n  background $bgdark\n\n  #addComponent\n    text-align left\n    width 200px\n    .select__control\n      background #161616\n      height 35px\n      color $primary\n\n  #addComponentHeader\n    font-size 15px\n    margin 5px 0 10px 0\n\n  input[type=text]:focus\n    box-shadow none\n\n.Select-menu-outer .is-focused span\n  color #fff\n\n.component-title\n  align-items center\n  display flex\n\n#componentEntityHeader\n  .collapsible-header\n    bottom 4px\n    position relative\n  .collapse-button\n    display none\n  .static\n    height 13px\n  .entityPrint\n    font-size 15px\n    padding-left 5px\n  .entityName\n    max-width 160px\n    top 0\n  .entityIcons\n    color #FAFAFA\n\n#mixinSelect\n  width 160px\n\n.propertyRow .texture\n  display flex\n  input\n    margin-left 0\n    width 120px\n\n#componentEntityHeader .gltfIcon img\n  top 0","@import './lib';\n\n.entityPrint\n  font-family $normalfont\n  line-height 1.15em\n\n.entityName\n  display inline-block\n  overflow hidden\n  position relative\n  text-overflow ellipsis\n  top 3px\n  white-space nowrap\n\n[data-entity-name-type=\"id\"]\n  color $red\n\n[data-entity-name-type=\"class\"]\n  color $green\n\n[data-entity-name-type=\"mixin\"]\n  color $orange\n",".help-lists\n  display flex\n  justify-content space-around\n\n.help-list\n  list-style none\n  margin 0\n  padding 0 0 10px\n  width 350px\n\n.help-list li\n  margin-right 40px\n\n.help-key-unit\n  line-height 1.8\n  margin-right 2em\n  padding 5px 0\n\n.help-key\n  bottom 2px\n  margin-right 4px\n  min-width 60px\n  position relative\n\n.help-key span\n  background-color #2e2e2e\n  background-repeat repeat-x\n  border 1px solid #666\n  border-radius 3px\n  box-shadow 0 0 5px #000\n  color #999\n  display inline-block\n  font-size 12px\n  padding 0 8px\n  text-align center\n\n.help-key-def\n  color #bbb\n  display inline-block\n  margin-left 1em\n","@import './lib';\n\n.select__control\n  border 0\n  border-radius 0\n  cursor pointer\n  min-height 26px\n  font-family $monospace\n  font-size 13px\n\n.select__indicator\n  height 26px\n\n.select__indicator-separator\n  display none\n\n.select__input\n  min-height auto !important\n\n.select__control,\n.select__menu\n  background $bgdark\n\n.select__option\n  padding 5px 10px\n\n.select__placeholder,\n.select__menu\n  color $white\n\n.select__single-value\n  color $primary\n\n.select__control--is-focused\n  box-shadow none !important\n\n.select__option\n  cursor pointer\n\n.select__label\n  font-size 11px\n\n.select__option--is-focused\n  background #155373\n\n.select__value-container\n  height 26px\n  position static\n  &.select__value-container--is-multi\n    height auto\n    padding 6px\n\n.select__dropdown-indicator\n  padding 3px 8px\n\n.select__multi-value\n  background $bg\n  color $primary\n\n.select__multi-value__label\n  color $primary\n\n.select__multi-value__remove:hover\n  color #fff\n  background $bg\n",".modal\n  animation animateopacity 0.2s ease-out\n  background-color rgb(0, 0, 0)\n  background-color rgba(0, 0, 0, 0.6)\n  display flex\n  height 100%\n  left 0\n  overflow auto\n  position fixed\n  top 0\n  width 100%\n  z-index 9999999999\n\n.modal h3\n  font-size 18px\n  font-weight 100\n  margin 0.6em 0\n\n#textureModal .modal-content\n  height calc(100% - 50px)\n  width calc(100% - 50px)\n\n.modal-content\n  animation animatetop 0.2s ease-out\n  animation-duration 0.2s\n  animation-name animatetop\n  background-color #232323\n  box-shadow 0 4px 8px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.5)\n  margin auto\n  overflow hidden\n  padding 0\n\n.close\n  color white\n  float right\n  font-size 28px\n  font-weight bold\n\n.close:hover,\n.close:focus\n  color #08f\n  cursor pointer\n  text-decoration none\n\n.modal-header\n  color white\n  padding 2px 16px\n\n.modal-body\n  overflow auto\n  padding 16px\n\n.modal-footer\n  color white\n  padding 2px 16px\n\n/* Gallery */\n.gallery\n  background #232323\n  display flex\n  flex-wrap wrap\n  margin 15px auto 0\n  max-height calc(100vh - 370px)\n  overflow auto\n  padding 15px 3px 3px\n\n.newimage .gallery\n  padding 16px\n\n.gallery li\n  border-radius 2px\n  box-shadow 0 0 6px rgba(0, 0, 0, 0.6)\n  cursor pointer\n  margin 8px\n  overflow hidden\n  width 155px\n\n.gallery li.selected,\n.gallery li:hover\n  box-shadow 0 0 0 2px #1eaaf1\n\n.gallery li .detail\n  background-color #323232\n  margin 0\n  min-height 60px\n  padding 3px 10px\n\n.preview\n  padding 10px\n  width 150px\n\n.preview input\n  display block\n  margin 8px 0\n  width 144px\n\n.preview button\n  width 155px\n\n.preview .detail .title\n  color #fff\n  display inline-block\n  max-width 155px\n  overflow hidden\n  text-overflow ellipsis\n  white-space nowrap\n\n.gallery li.selected .detail,\n.gallery li:hover .detail\n  background-color #444\n\n.gallery li .detail span\n  color #777\n  display block\n  margin-top 4px\n  overflow hidden\n  text-overflow ellipsis\n  white-space nowrap\n  width 140px\n\n.gallery li.selected .detail span,\n.gallery li:hover .detail span\n  color #888\n\n.gallery li .detail span.title\n  color #fff !important\n\n.modal button\n  appearance none\n  border-radius 0\n  box-shadow none\n  cursor pointer\n  display inline-block\n  font-size 12px\n  line-height 1.8\n  margin 0 10px 0 0\n  padding 5px 10px\n\n.modal button:focus\n  outline none\n\n.modal button\n  background-color #1eaaf1\n  border none\n  color #fff\n\n.modal button:hover,\n.modal button.hover\n  background-color #346392\n  text-shadow -1px 1px #27496d\n\n.modal button:active,\n.modal button.active\n  background-color #27496d\n  text-shadow -1px 1px #193047\n\n.modal button:disabled\n  background-color #888\n  cursor none\n\n.newimage\n  background-color #323232\n  color #bcbcbc\n  display flex\n  font-size 13px\n  justify-content space-between\n  margin-top 10px\n  overflow auto\n  padding 10px\n\n.newimage input\n  color #1eaaf1\n  padding 3px 5px\n\n.texture canvas + input\n  margin-left 5px\n\n.texture svg\n  padding-right 5px\n\n.uploader-normal-button .hidden\n  display none\n\n.assets.search\n  position relative\n  margin-top 10px\n  width 200px\n\n.assets.search svg\n  position absolute\n  right 0px\n  top 5px\n\n.new_asset_options\n  margin 10px\n\n.new_asset_options > ul\n  margin-left 10px\n  padding 5px\n\n.new_asset_options > ul > li\n  padding 10px 0\n\n.new_asset_options .imageUrl\n  margin-left 5px\n  width 350px\n\n.texture canvas\n  border 1px solid $bglight\n  cursor pointer\n","@import './lib';\n\n#viewportBar\n  align-items center\n  background-color $bg\n  color $white\n  display flex\n  flex-grow 2\n  height 32px\n  font-size 15px\n  justify-content space-between\n  left 0\n  margin 0 auto\n  right 0\n  top 0\n\n.toolbarButtons\n  display flex\n  align-items center\n  gap 6px\n\n  *\n    margin-left 0 !important\n    vertical-align middle\n\n  a.button\n    & svg\n      padding 8px\n\n    &:not(.active) svg:hover\n      background-color $grayhover\n\n  .active svg\n    background-color $primary\n    color #fff\n\n  .active:hover svg\n    color #fff !important\n\n.local-transform\n  padding-left 10px\n  padding-right 20px\n\n.local-transform label\n  color $lightgray\n  padding-left 5px\n\n.local-transform a.button\n  padding-top 0\n\n#cameraSelect\n  cursor pointer\n  width 120px\n  .select__dropdown-indicator\n    padding-left 3px\n    padding-right 3px\n\n#cameraToolbar\n  margin-left 5px\n  align-items center\n  display flex\n  a\n    margin-right 10px\n  .select__control\n    background none\n  .select__single-value\n    color $white\n    &:hover\n      color $primary\n\n#viewportHud\n  display none\n  +media--1024()\n    display block\n","@import './lib';\n\n.Select-control\n  background-color #222 !important\n  border none\n  border-radius 0\n  color $primary\n  font-family $monosapce\n\n.Select-menu-outer\n  border none\n\n.Select-menu-outer .is-focused\n  background-color $primary !important\n  color $white\n\n.Select-option\n  background-color #222 !important\n\n.select-widget\n  display inline-block\n  width 157px\n\n.Select-placeholder,\n.Select--single > .Select-control .Select-value\n  color $primary !important\n\n.Select-value-label\n  color $primary !important\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
